import type { USPAttributesGroup } from "@/types/sites";
import { USPAttributesIcon } from "../USPAttributesIcon";
import styles from "./USPAttributesIconGroup.module.css";

type USPAttributesGroupProps = ({
    pageUSPAttributes,
}: {
    pageUSPAttributes: USPAttributesGroup;
}) => React.ReactElement;

export const USPAttributesIconGroup: USPAttributesGroupProps = ({
    pageUSPAttributes,
}) => {
    const backgroundColor = pageUSPAttributes?.attributes?.attribution_group_background_color || "#eff2ff";
    return (
        <div className={styles.container} style={{ "--usp_attributes_background_color": backgroundColor } as React.CSSProperties}>
            {pageUSPAttributes?.attributes?.AGV.map((attribute) => (
                <USPAttributesIcon key={attribute.id} attribute={attribute} />
            ))}
        </div>
    );
};
